(() => {
  const root = document.querySelector('[data-product-root]');
  if (!root) return;
  const form = document.getElementById('GripPadProductForm');
  const variantSelect = document.getElementById('VariantId');
  const quantity = document.getElementById('Quantity');
  const image = document.getElementById('MainProductImage');
  const swatches = document.getElementById('ColorSwatches');
  const name = document.getElementById('ColorName');
  const price = document.getElementById('VariantPrice');
  const stockMessage = document.getElementById('VariantStock');
  const add = document.getElementById('AddToCart');
  const message = document.getElementById('ProductMessage');
  if (!form || !variantSelect || !quantity || !image || !swatches || !name || !price || !stockMessage || !add || !message) return;
  const labels = {
    add: root.dataset.addLabel,
    soldOut: root.dataset.soldOutLabel,
    unavailable: root.dataset.unavailableLabel,
    stock: root.dataset.stockLabel,
    inStock: root.dataset.inStockLabel,
    pack: root.dataset.packLabel,
    maximum: root.dataset.maximumLabel,
    roseFuchsia: root.dataset.roseFuchsiaLabel
  };
  const palettes = {
    Rectangle: [['Rose','#f18acb'],['Noir','#14151a'],['Marron foncé','#3b2921'],['Gris anthracite','#626970'],['Gris clair','#a5adb3'],['Café','#9c7054'],['Jaune','#ebdf13'],['Bleu','#086ed8'],['Bleu ciel','#32c4ee'],['Fuchsia','#e612bf'],['Violet','#8228c7'],['Rouge','#e62437'],['Transparent','#e6e2dc'],['Rose pâle','#ecd0e8'],['Vert citron','#84d315'],['Orange','#f3a11e'],['Turquoise','#45c6be'],['Blanc','#f8f8f7']],
    Papillon: [['Rose','#ef08a8'],['Bleu','#2822b7'],['Rouge','#d83633'],['Noir','#171819'],['Blanc','#fafafa'],['Rose clair','#f0acd1'],['Violet','#8320bd'],['Vert menthe','#b1e7d4'],['Turquoise','#62cab5'],['Vert citron','#77e60a'],['Lilas','#a5a1ed'],['Transparent','#dadfd9'],['Jaune','#efe86b'],['Orange','#f4a124']]
  };
  const options = Array.from(variantSelect.options);
  if (!options.length) return;
  const params = new URLSearchParams(window.location.search);
  const initial = options.find(option => option.value === params.get('variant')) || options.find(option => option.selected) || options[0];
  const requestedShape = params.get('shape') === 'papillon' ? 'Papillon' : params.get('shape') === 'rectangle' ? 'Rectangle' : initial.dataset.shape;
  let shape = options.some(option => option.dataset.shape === requestedShape) ? requestedShape : initial.dataset.shape;
  const firstForShape = () => options.find(option => option.dataset.shape === shape && option.dataset.color === 'Rose' && option.dataset.available === 'true') || options.find(option => option.dataset.shape === shape && option.dataset.available === 'true') || options.find(option => option.dataset.shape === shape);
  let color = initial.dataset.shape === shape ? initial.dataset.color : firstForShape().dataset.color;
  if (params.get('pack') === '5') quantity.value = '5';
  const displayColor = value => shape === 'Papillon' && value === 'Rose' ? labels.roseFuchsia : value;
  const selected = () => options.find(option => option.value === variantSelect.value);
  const stockLimit = option => option && option.dataset.managed === 'true' && option.dataset.policy !== 'continue' ? Math.max(0, Number(option.dataset.stock) || 0) : undefined;
  const remainingLimit = option => {
    const limit = stockLimit(option);
    return limit === undefined ? undefined : Math.max(0, limit - (Number(option.dataset.inCart) || 0));
  };
  const purchasable = option => Boolean(option && option.dataset.available === 'true' && remainingLimit(option) !== 0);

  function updateQuantity() {
    const option = selected();
    const available = purchasable(option);
    const limit = remainingLimit(option);
    const requested = Math.max(1, Math.floor(Number(quantity.value) || 1));
    const value = limit === undefined ? requested : Math.min(requested, Math.max(1, limit));
    quantity.value = String(value);
    if (limit === undefined) quantity.removeAttribute('max');
    else quantity.max = String(Math.max(1, limit));
    quantity.disabled = !available;
    add.disabled = !available;
    add.textContent = available ? labels.add : labels.soldOut;
    stockMessage.textContent = !available ? labels.soldOut : limit === undefined ? labels.inStock : labels.stock.replace('[count]', String(limit));
    message.textContent = !available ? labels.unavailable : requested > value ? labels.maximum.replace('[count]', String(value)) : value >= 5 ? labels.pack : '';
    root.querySelectorAll('[data-quantity]').forEach(button => {
      button.disabled = !available || (Number(button.dataset.quantity) < 0 ? value <= 1 : limit !== undefined && value >= limit);
    });
    const five = document.getElementById('ChooseFive');
    if (five) five.disabled = !available || (limit !== undefined && limit < 5);
  }

  function updateVariant() {
    const match = options.find(option => option.dataset.shape === shape && option.dataset.color === color);
    if (!match) {
      add.disabled = true;
      message.textContent = labels.unavailable;
      return;
    }
    variantSelect.value = match.value;
    name.textContent = displayColor(color);
    price.textContent = match.dataset.price;
    root.querySelectorAll('[data-shape-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.shapeChoice === shape)));
    swatches.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === color)));
    const url = new URL(window.location.href);
    url.searchParams.set('variant', match.value);
    url.searchParams.delete('shape');
    window.history.replaceState({}, '', url);
    updateQuantity();
  }

  function showImage(source, description) {
    image.src = source;
    image.alt = description;
    root.querySelectorAll('[data-gallery]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.gallery === source));
    });
  }

  function renderColors() {
    swatches.replaceChildren();
    const actual = options.filter(option => option.dataset.shape === shape);
    const palette = palettes[shape] || [];
    const sorted = [...actual].sort((a, b) => {
      const aIndex = palette.findIndex(entry => entry[0] === a.dataset.color);
      const bIndex = palette.findIndex(entry => entry[0] === b.dataset.color);
      return (aIndex < 0 ? palette.length : aIndex) - (bIndex < 0 ? palette.length : bIndex);
    });
    sorted.forEach(option => {
      const label = option.dataset.color;
      const hex = palette.find(entry => entry[0] === label)?.[1];
      const button = document.createElement('button');
      button.type = 'button';
      button.className = hex ? 'swatch' : 'swatch swatch-text';
      button.dataset.color = label;
      button.disabled = !purchasable(option);
      const accessible = displayColor(label) + (button.disabled ? ' — ' + labels.soldOut : '') + ' — ' + option.dataset.price;
      button.setAttribute('aria-label', accessible);
      button.title = accessible;
      if (hex) {
        button.style.setProperty('--swatch', hex);
        const chip = document.createElement('i');
        chip.setAttribute('aria-hidden', 'true');
        button.append(chip);
      } else {
        button.textContent = displayColor(label);
      }
      button.addEventListener('click', () => { color = label; updateVariant(); });
      swatches.append(button);
    });
    showImage(shape === 'Papillon' ? root.dataset.papillon : root.dataset.rectangle, shape === 'Papillon' ? root.dataset.papillonAlt : root.dataset.rectangleAlt);
    updateVariant();
  }

  root.querySelectorAll('[data-shape-choice]').forEach(button => {
    button.disabled = !options.some(option => option.dataset.shape === button.dataset.shapeChoice);
    button.addEventListener('click', () => {
      shape = button.dataset.shapeChoice;
      color = firstForShape().dataset.color;
      quantity.value = '1';
      renderColors();
    });
  });
  root.querySelectorAll('[data-gallery]').forEach(button => button.addEventListener('click', () => { showImage(button.dataset.gallery, button.dataset.galleryAlt || button.getAttribute('aria-label')); }));
  root.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => { quantity.value = String((Number(quantity.value) || 1) + Number(button.dataset.quantity)); updateQuantity(); }));
  const five = document.getElementById('ChooseFive');
  if (five) five.addEventListener('click', () => { quantity.value = '5'; updateQuantity(); });
  quantity.addEventListener('change', updateQuantity);
  variantSelect.addEventListener('change', () => {
    const option = selected();
    if (!option) return;
    shape = option.dataset.shape;
    color = option.dataset.color;
    renderColors();
  });
  form.addEventListener('submit', event => {
    updateQuantity();
    if (add.disabled) event.preventDefault();
  });
  root.querySelector('.native-variants').hidden = true;
  root.querySelector('.enhanced-options').hidden = false;
  renderColors();
})();
